module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/pc/profile_page/prefecture-0e2212ff1918d908156dbc2a8803b395.png";